import React, { FC } from "react";
import StyledDialog from "@components/StyledDialog";
import { Box, Grid2 as Grid } from "@mui/material";
import { Photo } from "@models/photo";
import { useTranslation } from "react-i18next";
import { PhotoSearchFilters } from "@store/photoApi";
import ImageContainer from "@components/AddPhotosDialog/ImageContainer";
import PhotoFilters from "@components/PhotoFilters";
import { useForm } from "react-hook-form";

interface AddPhotosDialogProps {
  onAddPhotos: (photos: Photo[]) => void;
  open: boolean;
  onClose: () => void;
  excludePhotos: Photo[];
  patientId: string;
  albumId?: string;
}

const AddPhotosDialog: FC<AddPhotosDialogProps> = ({
  onAddPhotos,
  open,
  onClose,
  excludePhotos,
  patientId,
  albumId,
}) => {
  const { t } = useTranslation();

  const form = useForm<PhotoSearchFilters>();

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      title={t(`albums.addPhotosDialog.title`)}
      height="80vh"
    >
      <Grid container spacing={2} flex="1">
        <Grid size={{ xs: 12, sm: 5, md: 4 }}>
          <PhotoFilters albumId={albumId} patientId={patientId} form={form} />
        </Grid>

        <Grid size={{ xs: 12, sm: 7, md: 8 }} position="relative">
          <Box
            sx={{
              position: { xs: "static", sm: "absolute" },
            }}
            width="100%"
            height="100%"
          >
            <ImageContainer
              form={form}
              onSave={onAddPhotos}
              excludePhotos={excludePhotos}
            />
          </Box>
        </Grid>
      </Grid>
    </StyledDialog>
  );
};

export default AddPhotosDialog;
